module.exports = __webpack_public_path__ + "img/87.504097de.jpg";